import { DateTime } from 'luxon';

const getRoundedToNearestHour = (millis: number): number => {
  const dateTime = DateTime.fromMillis(millis);

  if (dateTime.get('minute') < 30) {
    return dateTime.startOf('hour').toMillis();
  }

  return dateTime.plus({ hour: 1 }).startOf('hour').toMillis();
};

export default getRoundedToNearestHour;
